import { render, staticRenderFns } from "./ListaModelosVazia.vue?vue&type=template&id=f9bef328"
import script from "./ListaModelosVazia.vue?vue&type=script&lang=js"
export * from "./ListaModelosVazia.vue?vue&type=script&lang=js"
import style0 from "./ListaModelosVazia.vue?vue&type=style&index=0&id=f9bef328&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports